import mock from '@/fake-db/mock.js'

// Contact
const data = {
  labels: [
    {
      text: 'Reception',
      value: 'reception',
      color: 'danger'
    },
    {
      text: 'Transport to client (volume from quotation)',
      value : 'transport',
      color: 'success'
    },
    {
      text: 'Purchase Order',
      value: 'purchase order',
      color: 'warning'
    },/*
    {
      text: 'Inventory',
      value: 'inventory',
      color: 'warning'
    }*/
  ]
}

// GET: Fetch Calendar Labels
mock.onGet('api/apps/calendar/labels').reply(() => {
  return [200, data.labels]
})

